import Header from "./Header";
import Footer from "./Footer";
import HeroSection from "../components/tokenomics/HeroSection";
import DistributionSection from "../components/tokenomics/DistributionSection";
import WhatCanYouDo from "../components/tokenomics/WhatCanYouDo";
import MoreDetails from "../components/tokenomics/MoreDetails";
import tokenomicsShellStyle from "../styles/tokenomicsShellStyle";
import SeoHead from "../components/SeoHead";

const Tokenomics = () => {
  return (
    <div className="tokenomics-shell" style={tokenomicsShellStyle}>
      <SeoHead
        title="Atheriam Tokenomics - $ATH Utility & Distribution"
        description="Explore Atheriam $ATH tokenomics - supply, distribution, utility, staking, and how the token powers the gaming ecosystem."
        path="/tokenomics"
      />
      <Header />
      <main>
        <HeroSection />
        <DistributionSection />
        <WhatCanYouDo />
        <MoreDetails />
      </main>
      <Footer />
    </div>
  );
};

export default Tokenomics;
